
import { Options, Vue } from "vue-class-component";
import { ComputerActionTypes } from "@/store/modules/computer/action-types";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "@/store";

@Options({})
export default class pageHeader extends Vue {
  store = useStore();
  get headerConfig () {
     return this.store.state.computer.pageHeaderConfig;
  }
  created(): void { }
  exitEdit(){
      ElMessageBox.confirm("如果未保存此时离开将丢失已编辑的内容，是否离开？", "系统提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
      this.store.dispatch(ComputerActionTypes.ACTION_SUBMIT_AND_PREVIEW_PAGE, {preview:false, submit:false})
      this.$router.push({
       path: "/computer/construction/pageList",
        })
      })
      .catch(() => {
       ElMessage.info("已取消");
      });

  }
  headerBut(type:string){
    let params = {
        preview:false,
        submit:false
    }
    if (type === 'submit') {
        params.submit = true
        params.preview = false
    }else if(type === 'preview'){
        params.submit = false
        params.preview = true
    }
    this.store.dispatch(ComputerActionTypes.ACTION_SUBMIT_AND_PREVIEW_PAGE, params)

  }
  exitPreview(){
   this.store.dispatch(ComputerActionTypes.ACTION_SUBMIT_AND_PREVIEW_PAGE, {preview:false, submit:false})
  }

}
